import rung from "rung/src/rung";
import { fillConnectedAreas, getAdjacentCells, jaggedFloodFill } from "./flow";
import Tiles from "../tiles";

const rng = rung();

const prefab = [
  "~~~~~~~~~~~~~~~~...............~~~~~",
  "~~~..............................~~~",
  "~.................$.......$.....$..~",
  "~....$....#....$......#.....$......~",
  "~........####.####.######.#.....$.~~",
  "~...$..###....#....#....#.####....~~",
  ".........#...##..####......####..~~~",
  "...$....#.....................#...~~",
  "......##.....F................#....~",
  "..............................#..$..",
  ".....#......................#.......",
  ".....#...........%%.........###.....",
  "..$..#...........%%...........#.....",
  ".......#.........%%..........#......",
  "~....###....................##..$..~",
  "~.....###.................###......~",
  "~.......##.................#...$...~",
  "~..$...$..##.............##.$......~",
  "~............##.........##......$...",
  "~~.....$....#####.....####.$.......~",
  "~~~......$.....######.###.........~~",
  "~~~.....$...$.......$.....$..$...~~~",
  "~~~~.$..........$.....$........~~~~~",
  "~~~~~~~~~~~~~...........~~~~~~~~~~~~"
];

const TerrainCell = {
  ISLAND: ".",
  WALL: "#",
  FLOOR: "~",
  STATUE: "$",
  TABLE: "%",
  FATHER: "F",
  ENTRANCE: "<"
}

function generateFilledTerrain(width, height) {
  const grid = [];

  for (let y=0; y < height; y++) {
    grid[y] = [];
    for (let x=0; x < width; x++) {
      grid[y][x] = TerrainCell.FLOOR;
    }
  }

  return grid;
}

const defaultConfig = {
  islandSize: 550
}

const ruinedWall = [
  Tiles.RuinedWall1,
  Tiles.RuinedWall2,
  Tiles.RuinedWall3,
  Tiles.RuinedWall4
];

const statues = [
  Tiles.KoboldStatue,
  Tiles.KoboldStatue,
  Tiles.BardStatue,
  Tiles.AdventurerStatue,
  Tiles.PaladinStatue,
  Tiles.OrcStatue,
  Tiles.TrollStatue
];

function generateStatuary(configuration) {
  const config = { ...defaultConfig, ...configuration };
  const width = config.width;
  const height = config.height;

  const terrain = generateFilledTerrain(width, height);

  const origin = {
    x: Math.round(width / 2),
    y: Math.round(height / 2)
  }

  //jaggedFloodFill(terrain, origin, config.islandSize, TerrainCell.Island);

  const prefabAnchor = {
    x: Math.round(prefab[0].length - (origin.x / 2)),
    y: Math.round(prefab.length - (origin.y / 2))
  }

  // Splice in prefab
  for (let y=0; y < prefab.length; y++) {
    for (let x=0; x < prefab[0].length; x++) {
      terrain[y+prefabAnchor.y][x+prefabAnchor.x] = prefab[y][x];
    }
  }

  const tiles = [];

  for (let y=0; y < height; y++) {
    tiles[y] = terrain[y].map(cell => {
      switch (cell) {
        case TerrainCell.ISLAND: return Tiles.DungeonFlagstone;
        case TerrainCell.STATUE: return statues[rng.integer(0, 7)];
        case TerrainCell.FATHER: return Tiles.YourFather;
        case TerrainCell.WALL: return ruinedWall[rng.integer(0, 4)];
        case TerrainCell.TABLE: return Tiles.BanquetTable;
        default: return Tiles.PoolOfTears;
      }
    });
  }

  return {
    tiles,
    portals: {
      entrance: { y: 77, x: 0 }
    },
    features: {}
  }
}

export {
  generateStatuary
}
